<template>
  <div class="add-admin-user pad">
    <div class="pad">
      <admin-user-form @submitted="submitted" />
    </div>
  </div>
</template>

<script>
import AdminUserForm from '@/components/AdminUserForm'

export default {
  components: {
    AdminUserForm
  },
  methods: {
    submitted () {
      setTimeout(() => this.$router.push('/admin-users'), 300)
    }
  }
}
</script>

<style>

</style>
